import React, { Component, PropTypes } from 'react';
import Promise from 'bluebird';
import UnsavedChangesModal from './UnsavedChangesModal';

class AsyncUnsavedChangesModal extends Component {
    constructor(props) {
        super(props);
        this.promiseDelegates = {
            resolve: () => {},
            reject: () => {}
        };
        this.state = {
            isOpen: false
        };
    }
    ask = (primaryButtonAction, secondaryButtonAction) => {
        this.setState({
            isOpen: true
        });
        const askPromise = new Promise((resolve, reject) => {
            this.promiseDelegates.resolve = resolve;
            this.promiseDelegates.reject = reject;
        }).then(() => Promise.method(primaryButtonAction)(), secondaryButtonAction);

        return askPromise;
    };
    answer = value => {
        this.setState({
            isOpen: false
        });

        value ? this.promiseDelegates.resolve(value) : this.promiseDelegates.reject(value);
    };

    primaryButtonClick = () => this.answer(true);
    secondaryButtonClick = () => this.answer(false);

    render() {
        return (
            this.state.isOpen && (
                <UnsavedChangesModal
                    level={this.props.level}
                    chain={this.props.chainId}
                    hotel={this.props.hotelId}
                    onClose={this.secondaryButtonClick}
                    onPrimaryClick={this.primaryButtonClick}
                    onSecondaryClick={this.secondaryButtonClick}
                    titleName={this.props.titleName}
                />
            )
        );
    }
}

AsyncUnsavedChangesModal.propTypes = {
    level: PropTypes.string,
    chainId: PropTypes.string,
    hotelId: PropTypes.string,
    titleName: PropTypes.string
};

export { AsyncUnsavedChangesModal };



// WEBPACK FOOTER //
// ./src/components/modals/AsyncUnsavedChangesModal.js